export default __webpack_public_path__ + "static/media/Interactive Musuem Map.25d5ee6b.svg";